module.exports = __webpack_public_path__ + "media/images/lb/189-15b028c01d008098c75f94872352fcf5.svg";